import { generateAnalyticsCb } from '@cld/analytics';

type AnalyticsAction = 'navigate' | 'sign up' | 'play' | 'learn more' | 'click' | 'navigation' | 'external navigation'
  | 'login' | 'edit general' | 'show-hide' | 'edit client side design' | 'edit asset selection'
  | 'edit default transformations' | 'edit custom transformations' | 'remove' | 'edit open console'
  | 'expand' | 'collapse' | 'copy to clipboard';

export interface AnalyticsData {
  eventAction: AnalyticsAction;
  eventLabel: string;
}

export const useAnalytics = () => (eventAction: AnalyticsAction, eventLabel: string) =>
  generateAnalyticsCb({ eventAction, eventLabel })();
